import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild
} from "@angular/core";
import * as _ from "lodash";
import { asyncScheduler } from "rxjs";
import { AppState, RoleMgr, ShowRequest } from "../../core";
import { AppTab } from "../../core/app-tab";
import { activity_status, MapWaypoint } from "../../core/models";
import { TableColumn, TableViewContext } from "../../shared/components/table-view/table-view-component-base";
import { VolunteerTaskPointViewRecord } from "../models/volunteer-task-point-record";
import { VolunteerTaskRecord } from "../models/volunteer-task-record";
import { ScoutPointInfo } from "../../core/services/scout-point.service";
import { VolunteerTaskPointService } from "../services/volunteer-task-point.service";
import {
  TaskPtRecs,
  VolunteerPtRecInfo,
  VolunteerTaskPointsTableComponent,
} from "./volunteer-task-points-table.component";

@Component({
  selector: "app-volunteer-task-points",
  templateUrl: "volunteer-task-points.component.html",
  styleUrls: ["volunteer-task-points.component.scss"]
})
export class VolunteerTaskPointsComponent implements OnDestroy, AfterViewInit {
  @Input() tabConfig: AppTab;

  @Input() contextJson: string;

  @Input() contextJsonChangeHandler: (itemId: string, tab: AppTab) => void;

  @Input() localContext: string = null;

  @Input() stage: string;

  @Input() tempHack = false;

  @Input() task: VolunteerTaskRecord;

  @Input() readonly = false;

  @Input() loadTrigger: EventEmitter<void>;

  // @Input('scoutAndPathResolver$') set scoutAndPathResolverSetter( spr: Observable<{pathId:string,scoutTask:ScoutTaskDoc,scoutPath:ScoutPath}>){
  //   this.scoutAndPathResolverSub?.unsubscribe();
  //   this.scoutAndPathResolverSub = spr?.subscribe( scoutPathInfo => {
  //     console.log('got scout path info to update table with')
  //     console.dir(scoutPathInfo);
  //   })
  // }
  // scoutAndPathResolverSub: Subscription;
  PointStatus = activity_status;

  @ViewChild("taskPointsTable") taskPointsTable: VolunteerTaskPointsTableComponent;

  @Output("taskPointIdClick") taskPointIdClick = new EventEmitter<{
    rec: VolunteerTaskPointViewRecord;
    scoutInfo: ScoutPointInfo;
  }>();

  @Output("taskPointEditClick") taskPointEditClick =
    new EventEmitter<VolunteerPtRecInfo>();

  @Output("taskPointsChanged") taskPointsChanged =
    new EventEmitter<TaskPtRecs>();

  @Input() selectedRec: VolunteerTaskPointViewRecord;
  @Output() selectedRecChanged =
    new EventEmitter<VolunteerTaskPointViewRecord>();

  selectedMapPoint: MapWaypoint;
  lastCallTime: string = null;

  notPrintableQrByPtStatus: { [status: number]: boolean } = {};

  constructor(public roleMgr: RoleMgr, protected appState: AppState, public volunteerTaskPointService: VolunteerTaskPointService) {
    this.notPrintableQrByPtStatus[activity_status.Id.NOT_USING] = true;
    this.notPrintableQrByPtStatus[activity_status.Id.ARCHIVED] = true;
  }

  ngOnDestroy(): void {
    //this.scoutAndPathResolverSub?.unsubscribe();
  }

  ngAfterViewInit(): void {
    asyncScheduler.schedule(() => {
      this.taskPointsTable.load().catch(e => {
        this.appState.publishError(e, this);
      });
    });
  }

  // Temporarly uncomment these in template html to do type checking (don't check in uncommented!!!)
  typedRecord = (r: VolunteerTaskPointViewRecord) => r;
  typedColumn = (c: TableColumn) => c;

  showPath(rec: VolunteerTaskPointViewRecord) {
    this.appState.showView.next(
      new ShowRequest(
        "tab",
        "path",
        JSON.stringify({
          pathId: rec.pathId,
          buildingId: rec.buildingId,
          defaultPointId: rec.pointId,
        }),
        null
      )
    );
  }

  onShowRutLog = () => {
    const queryForTaskPoint: Partial<TableViewContext> = {
      filters: [{
        key: 'taskId',
        value: `${this.task.id}`,
        mode: '='
      }],
      sorts: [
        {
          key: 'startTime',
          order: 'DESC'
        }
      ]
    };
    this.appState.showView.next(
      new ShowRequest('tab', 'rut call logs', JSON.stringify(queryForTaskPoint))
    );
  };

  onMapWaypointSelected(mapPoint: MapWaypoint) {
    console.dir(mapPoint);
    if (this.selectedRec?.pointId != mapPoint.pointId) {
      const rec = this.taskPointsTable.records.find(
        (rec) => rec.pointId == mapPoint.pointId
      );
      this.setSelectedRec(rec);
    }
    this.selectedMapPoint = mapPoint;
  }

  showTaskPoint = (rec: VolunteerTaskPointViewRecord) => {
    this.selectedRec = null; // this removes map so it can re-init
    asyncScheduler.schedule(() => {
      this.selectedRec = rec;
    });
  };

  onTaskPointIdClick(rec: VolunteerTaskPointViewRecord) {
    this.setSelectedRec(rec);
    this.taskPointIdClick.emit({
      rec,
      scoutInfo: this.taskPointsTable?.scoutInfoByRecId?.[rec.id],
    });
  }

  onTaskPointEditClick(rec: VolunteerTaskPointViewRecord) {
    this.setSelectedRec(rec);
    this.taskPointEditClick.emit({
      rec,
      scoutInfo: this.taskPointsTable?.scoutInfoByRecId?.[rec.id],
    });
  }

  onTaskPointsChanged(recs: VolunteerTaskPointViewRecord[]) {
    const scoutInfoByRecId = this.taskPointsTable?.scoutInfoByRecId;
    const mobilePhotoIdsByRecId = this.taskPointsTable?.mobilePhotoIdsByRecId;
    this.lastCallTime = _.orderBy(this.taskPointsTable?.records?.filter(r=>r.lastCallTime),['lastCallTime']).last()?.lastCallTime;
    this.taskPointsChanged.emit({ recs, scoutInfoByRecId, mobilePhotoIdsByRecId });
  }

  protected setSelectedRec(rec: VolunteerTaskPointViewRecord) {
    const last = this.selectedRec;
    this.selectedRec = rec;
    if (last != this.selectedRec) {
      this.selectedRecChanged.emit(this.selectedRec);
    }
  }

  labelGrid(taskid: number) : string{
    return 'labelGrid'+taskid;
  }

  bindMobilePhotoContextForTaskPoint = this.volunteerTaskPointService.bindMobilePhotoContextForTaskPoint;

  toggleMobilePhotoForTaskPoint = this.volunteerTaskPointService.toggleMobilePhotoForTaskPoint;

}

